import { Translate } from 'react-redux-i18n'

export const TranslateItemSelect = ({ count }) => (
  <Translate
    value={`library.main.${
      !count || count < 2 ? 'ITEM_SINGLE_SELECT' : 'ITEM_SELECT'
    }`}
    count={count}
  />
)

export const TranslateDeletePortfolio = ({ count }) => (
  <Translate
    value={`library.savePortfolio.${
      count > 2 ? 'TEXT_DELETE_PORTFOLIOS' : 'TEXT_DELETE_PORTFOLIO_SINGLE'
    }`}
    count={count}
  />
)
